/**
 * Route redirect utility.
 * Builds redirect URLs for legacy route migration while preserving query parameters.
 */

/**
 * Builds a redirect URL from a legacy path to the new `/practice/lld` path,
 * preserving any query parameters from the original URL.
 *
 * @param originalPath - The original path being navigated to (e.g., "/system-design/lld")
 * @param queryString - The query string to preserve (e.g., "?tab=overview" or "tab=overview")
 * @returns The new redirect URL with preserved query params (e.g., "/practice/lld?tab=overview")
 */
export function buildRedirectUrl(originalPath: string, queryString: string): string {
 const basePath = '/practice/lld';

 if (!queryString || queryString.trim().length === 0) {
  return basePath;
 }

 // Normalize: strip leading '?' if present
 const normalizedQuery = queryString.startsWith('?')
  ? queryString
  : `?${queryString}`;

 return `${basePath}${normalizedQuery}`;
}
